<template>
  <div class="product-details-image-container">
    <img
      class="product-details-image aspect-square"
      :src="activeImage.mimeSource[language]"
    />
    <div class="product-image-selector">
      <img
        v-for="m in mimes"
        :class="[
          'product-details-image-preview',
          activeImage.index === m.index ? 'active' : '',
        ]"
        :key="m.index"
        :src="m.mimeSource[language]"
        @click="setActive(m.index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductImageViewer",
  props: {
    mime: {
      type: Array,
      default: () => [],
      required: true,
    },
    language: {
      type: String,
      default: "en",
    },
  },
  methods: {
    setActive(index) {
      this.activeMimeIndex = index;
    },
  },
  data() {
    return {
      activeMimeIndex: 0,
    };
  },
  computed: {
    activeImage() {
      return this.mimes[this.activeMimeIndex];
    },
    mimes() {
      return this.mime
        ?.filter((mm) => {
          if (
            mm.mimeSource?.[this.language]?.includes(".jpeg") ||
            mm.mimeSource?.[this.language]?.includes(".jpg") ||
            mm.mimeSource?.[this.language]?.includes(".png")
          ) {
            return true;
          }
          return false;
        })
        .map((m, index) => ({
          ...m,
          index,
        }));
    },
  },
};
</script>

<style>
.product-details-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-details-image-container img {
  object-fit: contain;
  border: 1px solid var(--rofix-light-gray);
}

.product-details-image {
  height: 400px;
  width: 400px;
  margin-bottom: 10px;
}

.product-image-selector {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.product-details-image-preview {
  height: 80px;
  width: 80px;
  cursor: pointer;
}

.product-details-image-preview.active {
  border: 2px solid var(--rofix-primary);
}
</style>
